import http from "../httpService";
import { apiUrl } from "../../../config.js";
const apiEndpoint = apiUrl + "/production/";
export function savePlant(plant) {
  return http.post(apiEndpoint + "plant", plant);
}

export function getPlants() {
  return http.get(apiEndpoint + "plants");
}

export function getPlant(plantID = 0) {
  return http.get(apiEndpoint + `plant/${plantID}`);
}

export function deletePlant(plantID = 0) {
  return http.delete(apiEndpoint + `plant/${plantID}`);
}

export function getProductionDetail(itemID = 0, varCode = "-") {
  return http.get(apiEndpoint + `production-detail/${itemID}/${varCode}`);
}

export function getPlantWarehouses(plantID = 0) {
  return http.get(apiEndpoint + `plant-warehouses/${plantID}`);
}

export function saveProductionOrder(productionOrder) {
  return http.post(apiEndpoint + `production-order`, productionOrder);
}

export function getProductionOrderList() {
  return http.get(apiEndpoint + `production-order-list`);
}

export function getProductionOrderDetail(productionOrderID = 0) {
  return http.get(apiEndpoint + `production-order-detail/${productionOrderID}`);
}

export function getProductionOrderWarehouses(productionOrderID = 0) {
  return http.get(
    apiEndpoint + `production-order-warehouses/${productionOrderID}`
  );
}

export function getProductionOrderStocks(productionOrderID = 0) {
  return http.get(apiEndpoint + `production-order-stocks/${productionOrderID}`);
}

export function unloadProductionStock(stockUnload) {
  return http.post(apiEndpoint + `production-order-stock-unload`, stockUnload);
}
